/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService, PusherService, AuthService } from "@app/@core/services";
import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBWb5Aa6MKWSGBwn9X3_ooKxAA5TXa6dGw",
  authDomain: "legacy-fa-fdfab.firebaseapp.com",
  projectId: "legacy-fa-fdfab",
  storageBucket: "legacy-fa-fdfab.appspot.com",
  messagingSenderId: "410427816682",
  appId: "1:410427816682:web:5ac45e5b01890d81d3f593"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const db = app.firestore();

@Component({
  selector: "app-tv-sales-production",
  templateUrl: "./tv-sales-production.component.html",
  styleUrls: ["./tv-sales-production.component.scss"],
})
export class TvSalesProductionComponent implements OnInit, OnDestroy {
  private submissionSub: Subscription;

  loading = true;
  leaderboard_title;
  leaderboard_desc;

  ape_leaderboard_left = [];
  ape_leaderboard_right = [];
  ape_stats;

  constructor(private authService: AuthService, private router: Router, private apiService: ApiService, private pusherService: PusherService) {
    this.getLeaderboardAPE();
    this.testFB();
  }

  // Get a list of cities from your database
  testFB() {
    const monthlyAPE = db.collection('leaderboards');
    const snapshot = monthlyAPE.doc('monthly-ape').onSnapshot((snapshot) => {
      console.log(snapshot.id, '=>', snapshot.data());
    });
  }

  ngOnInit() {
    this.pusherService.channel_submission = this.pusherService.pusherClient.subscribe("submission");
    this.pusherService.channel_submission.bind("submission", (data) => this.pusherService.subject_monitorSubmissions.next(data));
    this.submissionSub = this.pusherService.monitorSubmissions().subscribe((data) => {
      this.getLeaderboardAPE();
    });
  }

  ngOnDestroy() {
    if (this.submissionSub) this.submissionSub.unsubscribe();
    if (this.pusherService.channel_submission) this.pusherService.channel_submission.unbind();
  }

  // 'fyc' | 'submission-ape' | 'incepted-policies'
  getLeaderboardAPE(leaderboard_type = "submission-ape") {
    this.loading = true;
    this.ape_leaderboard_left = [];
    this.ape_leaderboard_right = [];
    this.apiService
      .post("dashboard/leaderboard/associates", {
        type: leaderboard_type,
        range: "month",
        limit: 20,
      })
      .subscribe((result) => {
        console.log(result);
        if (result.error === false) {
          for (let i = 0; i < 20; i++) {
            if (result["data"][i]) {
              if (i < 10) this.ape_leaderboard_left.push(result["data"][i]);
              else this.ape_leaderboard_right.push(result["data"][i]);
            }
          }
          this.ape_stats = result["stats"];
          this.leaderboard_title = "APE Ranking" + " (" + this.ape_stats["date"] + ")";
          this.leaderboard_desc = "By Case Submissions APE";

          this.loading = false;
        }
      });
  }
}
